import { updateYoutubeSafeMode } from './safeSearch/youtube/youtubeRestrictedMode';
import { isFullyConfigured } from './helper/authentication';
import { updateProtectionPopup } from './popup/protectionPopup';
import { isSafeNetworkDelegated } from './safeNetworks/safeNetworksDelegation';
import { updateSafeNetworkStateIfEnabled } from './safeNetworks';
import { isDelegationStopped } from './delegation/delegation';
import { updateTabsStateIfNeeded } from './chrome/tabManager';

export type ProtectionStatus =
  | 'protected'
  | 'safe_network_delegated'
  | 'delegation_stopped'
  | 'unprotected';
export const getProtectionStatus = (): ProtectionStatus => {
  if (isDelegationStopped()) {
    return 'delegation_stopped';
  }
  if (isSafeNetworkDelegated()) {
    return 'safe_network_delegated';
  }
  if (isProtectionEnabled()) {
    return 'protected';
  }
  return 'unprotected';
};

/**
 * Returns if the protection is enabled.
 *
 * @returns
 * TRUE if the extension is onboarded and ready to protect
 * FALSE otherwise
 * @remarks
 * It does not take into account the Safe Networks or Delegation states
 */
export const isProtectionEnabled = () => isFullyConfigured();

/**
 * Returns if the protection is active.
 *
 * @returns
 * TRUE if the extension is actively protecting. It takes into account the Safe Networks or Delegation states
 * FALSE otherwise
 */
export const isProtectionActive = () => getProtectionStatus() == 'protected';

/**
 * This will refresh the protection status of the extension:
 *
 * - Enable/Disable the YouTube safe mode if needed
 * - Update the protection popup if needed
 * - Update Safe Network state (optional)
 * - Update the tabs state if needed
 * @param updateSafeNetworkState - Whether to update the Safe Network state
 * @param context - Optional context string describing why this function was called
 */
export const refreshProtectionStatus = async (
  updateSafeNetworkState = true,
  context: string
) => {
  await updateYoutubeSafeMode();
  await updateProtectionPopup();
  if (updateSafeNetworkState) {
    await updateSafeNetworkStateIfEnabled();
  }

  await updateTabsStateIfNeeded(context);
};
